import { mqLaptop, mqTabletPortrait, mqPhone } from '../../utils/mq';

document.addEventListener('alpine:init', () => {
  Alpine.data('paymentMethodsNew', () => ({
    items: [],

    filteredItems: [],

    keywords: '',

    location: 'all',

    type: 'all',

    authenticationType: 'all',

    page: 1,

    perPage: 20,

    lastPage: 0,

    count: 0,

    pagination: [],

    ppmsPerCountry: {},

    init() {
      /*if (mqPhone.matches) {
        this.perPage = 6;
      } else if (mqTabletPortrait.matches) {
        this.perPage = 9;
      } else if (mqLaptop.matches) {
        this.perPage = 20;
      } else {
        this.perPage = 20;
      }*/

      this.items = [...this.$root.querySelectorAll('.payment-methods-filterable__results-items--static > span')].map(
        (el) => {
          const consumerCountryNames = el.dataset.consumerCountryNames.split(', ');
          const visibleConsumerCountryNames = [];
          let characters = 0;

          do {
            if (
              visibleConsumerCountryNames.length &&
              consumerCountryNames.length &&
              characters + consumerCountryNames[0].length > 36
            ) {
              break;
            }

            const consumerCountryName = consumerCountryNames.shift();
            characters += consumerCountryName.length;
            visibleConsumerCountryNames.push(consumerCountryName);
          } while (consumerCountryNames.length && characters <= 36);

          return {
            id: +el.dataset.id,
            name: el.dataset.name,
            image: el.dataset.image,
            link: el.dataset.href,
            types: el.dataset.types.split(',').map(Number),
            authenticationTypes: el.dataset.authenticationTypes.split(',').map(Number),
            regions: el.dataset.regions.split(','),
            consumerCountries: el.dataset.consumerCountries.split(',').map(Number),
            countries: el.dataset.countries.split(',').map(Number),
            typeNames: el.dataset.typeNames,
            authenticationTypeNames: el.dataset.authenticationTypeNames,
            consumerCountryNames: visibleConsumerCountryNames.join(', ') || '-',
            countryNames: visibleConsumerCountryNames.join(', ') || '-',
            countryNamesRest: consumerCountryNames,
            comingSoon: el.dataset.comingSoon === '1',
            badge: JSON.parse(el.dataset.badge.replace(/§/g, '"')),
            weight: +el.dataset.weight,
          };
        }
      );

      this.ppmsPerCountry = JSON.parse(this.$refs.ppmsPerCountry.innerHTML.trim());

      window.addEventListener('popstate', () => this.parseURL());

      this.parseURL();
    },

    parseURL(scrollIntoView = false) {
      const { keywords, location, type, authenticationType, page } = this.extractParams(
        new URLSearchParams(window.location.search)
      );

      this.keywords = keywords;
      this.location = location;
      this.type = type;
      this.authenticationType = authenticationType;
      this.page = page;

      this.filter(scrollIntoView);
    },

    filter(scrollIntoView = false) {
      const results = this.items.filter((row) => {
        if (this.location !== 'all' && this.location.match(/^[a-z]/i)) {
          const region = this.location;

          if (!row.regions.some((_region) => region === _region)) {
            return false;
          }
        } else if (this.location !== 'all' && !row.consumerCountries.includes(+this.location)) {
          return false;
        }

        if (this.type !== 'all' && !row.types.includes(+this.type)) {
          return false;
        }

        if (this.authenticationType !== 'all' && !row.authenticationTypes.includes(+this.authenticationType)) {
          return false;
        }

        if (this.keywords.trim() && !row.name.toLowerCase().includes(this.keywords.trim().toLowerCase())) {
          return false;
        }

        return true;
      });

      /*if (this.location !== 'all' && this.location.match(/^[1-9][0-9]*$/) && this.ppmsPerCountry[this.location]) {
        results.sort(
          (a, b) => this.ppmsPerCountry[this.location].indexOf(a.id) - this.ppmsPerCountry[this.location].indexOf(b.id)
        );
      } else {
        results.sort((a, b) => b.weight - a.weight);
      }*/
      results.sort((a, b) => b.weight - a.weight);

      this.count = results.length;
      this.lastPage = Math.ceil(this.count / this.perPage);
      this.page = Math.max(Math.min(this.page, this.lastPage), 1);
      this.pagination = [];

      const paginationStart = Math.max(1, this.page - 2);
      const paginationEnd = Math.min(paginationStart + 4, this.lastPage);

      for (let i = paginationStart; i <= paginationEnd; i++) {
        this.pagination.push(i);
      }

      const missing = 5 - this.pagination.length;

      for (let i = 0; i < missing; i++) {
        if (paginationStart - i - 1 >= 1) {
          this.pagination.unshift(paginationStart - i - 1);
        }
      }

      this.filteredItems = results.slice((this.page - 1) * this.perPage, (this.page - 1) * this.perPage + this.perPage);

      if (scrollIntoView) {
        setTimeout(() => {
          window.scrollTo(0, this.$refs.results.offsetTop - 200);
        });
      }
    },

    push(page, scrollIntoView = false) {
      const { url } = this.extractParams(
        new URLSearchParams({
          _keywords: this.keywords,
          _location: this.location,
          _type: this.type,
          _authenticationType: this.authenticationType,
          _page: page ?? this.page,
        })
      );

      if (url.search !== window.location.search) {
        window.history.pushState({}, '', url);
        this.parseURL(scrollIntoView);
      }
    },

    extractParams(params) {
      const keywords = params.get('_keywords') ?? '';
      const location = params.get('_location') ?? 'all';
      const type = params.get('_type') ?? 'all';
      const authenticationType = params.get('_authenticationType') ?? 'all';
      const page = params.get('_page') && /^[1-9][0-9]*$/.test(params.get('_page')) ? +params.get('_page') : 1;

      const url = new URL(window.location.href);
      const newParams = new URLSearchParams();

      if (keywords) {
        newParams.append('_keywords', keywords);
      }

      if (location !== 'all') {
        newParams.append('_location', location);
      }

      if (type !== 'all') {
        newParams.append('_type', type);
      }

      if (authenticationType !== 'all') {
        newParams.append('_authenticationType', authenticationType);
      }

      if (page !== 1) {
        newParams.append('_page', page);
      }

      url.search = newParams.toString();

      return { page, keywords, location, type, authenticationType, url, params: newParams };
    },

    clearKeywords() {
      this.keywords = '';
      this.push();
    },
  }));
});